import React, { useState, useEffect, useRef } from 'react'
import PropTypes from "prop-types";
import { Spinner } from 'reactstrap';

import {
    CLOSE,
    TRANSLATE_ITEM_CONFIRMATION,
    TRANSLATE_ITEM_MSG,
    TRANSLATE_LABEL
} from "../i18n/i18n";

/**
 *
 * @param translate function to execute the translate order
 * @param onClose modal close function
 * @param itemID item id to translate
 * @param fbDB current firebase id
 * @returns {JSX.Element}
 * @returns {JSX.Element}
 * @constructor
 */
const TranslateItem = ({
     translate,
     onClose,
     itemID,
     fbDB,
 }) => {
    const [translating, setTranslating] = useState( false )

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() =>{
        return ()=>{
            isMounted.current = false
        }
    },[])

    const handleTranslate = () => {
        setTranslating(true)

        translate(itemID, fbDB)
        //onClose()
    }

    return (<div className='custom-ui'>
        <h1>{TRANSLATE_ITEM_CONFIRMATION}</h1>
        <p>{TRANSLATE_ITEM_MSG}</p>

        <button onClick={ onClose }>{CLOSE}</button>
        <button className={"btn-alert-delete"}
                disabled={ translating }
                onClick={ handleTranslate }
        >
            {
                translating
                    ? <>
                        <Spinner animation="border" size='sm' type='grow'/>
                        <Spinner animation="border" size='sm' type='grow'/>
                        <Spinner animation="border" size='sm' type='grow'/>
                    </>
                    : TRANSLATE_LABEL
            }
        </button>
    </div>)
}

TranslateItem.propTypes = {
    translate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    itemID: PropTypes.string.isRequired,
    fbDB: PropTypes.string.isRequired,
}

export default TranslateItem
